var Factories = angular.module('RessieApp.factories', [
  'RessieApp.factories.users',
  'RessieApp.factories.socket'
]);